export default __webpack_public_path__ + "static/TypeMates-SombraMedium-b309374980ba25d1fb8ad6840fc64d68.otf";